import { formatAdminDisplayName } from '../../../../utils/adminDisplayName';

export const resolveEventAnnouncementSenderName = (message) => {
  if (message?.isAdminMsg) {
    const name = formatAdminDisplayName({
      adminDisplayName: message?.admin_display_name || '',
      fullName: message?.admin_full_name || '',
      username: message?.admin_username || '',
      role: message?.admin_role || '',
      isExternalAccount: message?.admin_is_external_account === true,
      externalAffiliationName: message?.admin_external_affiliation_name || '',
      useAsciiParentheses: true,
    });
    if (name) return name;
    if (message?.artist_name) return message.artist_name;
    return 'お知らせ';
  }
  return message?.artist_name || 'お知らせ';
};

export const resolveEventMessageSourceEventName = (message) =>
  String(message?.source_event_name || '').trim();

export const resolveEventMessageSourcePerformanceType = (message) =>
  String(message?.source_performance_type || '').trim();

export const resolveEventMessageSourceBadgeLabel = (message) => {
  const performanceType = resolveEventMessageSourcePerformanceType(message);
  if (performanceType) return performanceType;
  return resolveEventMessageSourceEventName(message);
};

export const shouldShowEventMessageSourceBadge = ({
  message,
  isSelectedGroupUnified = false,
  selectedEventInfo = null,
  selectedEventId = '',
  resolveEventChatMode,
  resolveEventGroupCount,
  unifiedMode = 'group_unified',
}) => {
  if (isSelectedGroupUnified) return false;
  const sourceLabel = resolveEventMessageSourceBadgeLabel(message);
  if (!sourceLabel) return false;

  const sourceEventId = String(message?.source_event_id || '').trim();
  const selectedEventUuid = String(selectedEventInfo?.event_uuid || selectedEventId || '').trim();
  const selectedName = String(selectedEventInfo?.name || '').trim();
  const selectedPerformanceType = String(selectedEventInfo?.performance_type || '').trim();
  const selectedGroupMode = resolveEventChatMode(selectedEventInfo || {});
  const selectedGroupCount = resolveEventGroupCount(selectedEventInfo || {});

  if (selectedGroupMode === unifiedMode) {
    return false;
  }

  if (selectedGroupMode !== unifiedMode && selectedGroupCount <= 1) {
    if (sourceEventId && selectedEventUuid && sourceEventId === selectedEventUuid) {
      return false;
    }
    if (
      !sourceEventId &&
      ((selectedPerformanceType && sourceLabel === selectedPerformanceType) ||
        (selectedName && sourceLabel === selectedName))
    ) {
      return false;
    }
  }
  return true;
};
